import { CourseType, UserType } from '../../../types'

export const getCourseCheckout = (course?: CourseType, user?: UserType) => {
  if (!course?.checkout) {
    return
  }

  if (user?.stripeSubscriptionStatus === 'Active' && !user?.trial) {
    return course.memberCheckout || course.checkout
  }

  return course.checkout
}
